import type { BulletTag } from '@/data/types';

/**
 * Human-facing labels for the bullet tags.
 *
 * The raw tag values are authoring shorthand; these are what a visitor reads.
 * Kept separate from the data so renaming a label never touches resume output.
 */
export const TAG_LABELS: Record<BulletTag, string> = {
  backend: 'Backend',
  cloud: 'Cloud',
  data: 'Data',
  delivery: 'Delivery',
  devops: 'DevOps',
  frontend: 'Frontend',
  leadership: 'Ownership',
  quality: 'Quality & testing',
  security: 'Security',
};

/** Order chips by how much evidence backs them, then alphabetically. */
export function orderTags(counts: Map<BulletTag, number>): BulletTag[] {
  return [...counts.keys()].sort((a, b) => {
    const diff = (counts.get(b) ?? 0) - (counts.get(a) ?? 0);
    return diff !== 0 ? diff : TAG_LABELS[a].localeCompare(TAG_LABELS[b]);
  });
}
